import { FormattedMessage, useIntl } from 'react-intl'
import Text from 'components/shared/Text'
import Modal from 'components/shared/Modal'
import Box from 'components/shared/Box'
import {
    UNLIMITED_1ST_RENEW_REGULATIONS_LINK,
    UNLIMITED_2ND_RENEW_REGULATIONS_LINK,
} from 'constants/links'
import UnlimitedAdvantages from 'components/global/UnlimitedAdvantages'

interface UnlimitedProlongingAdvantagesModalProps {
    isOpened: boolean
    handleModalOpened: (isOpened: boolean) => void
}

const UnlimitedProlongingAdvantagesModal = ({
    isOpened,
    handleModalOpened,
}: UnlimitedProlongingAdvantagesModalProps) => {
    const { formatMessage } = useIntl()

    const handleClose = () => handleModalOpened(false)

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={handleClose}
            isMobileFullscreen
            hasGlobalHeader
            headerMessage={formatMessage({
                id: 'annual.renew.advantages_modal_header',
                defaultMessage: 'Korzyści z przedłużenia karty Unlimited',
            })}
            testIdPrefix="unlimited-renew-advantages"
        >
            <Box
                bgColor="grayscale_200"
                pt={[24, 40]}
                pl={[16, 40]}
                pb={[24, 40]}
                pr={[16, 40]}
            >
                <Text variant="bodyLarge" color="grayscale_900">
                    <FormattedMessage
                        id="annual.renew.advantages_modal_cta"
                        defaultMessage="Im dłużej, tym lepiej! <break></break>Przedłuż swoją kartę Unlimited i zyskaj jeszcze więcej korzyści!"
                        values={{
                            break: () => <br />,
                        }}
                    />
                </Text>
                <Box mt={32}>
                    <Text variant="heading4" color="grayscale_900" mb={16}>
                        <FormattedMessage
                            id="annual.renew.advantages_modal_1y_caption"
                            defaultMessage="Po pierwszym roku:"
                        />
                    </Text>
                    <UnlimitedAdvantages
                        iconVariant="violet"
                        cardEdition="blue"
                    />
                    <Text
                        variant="bodyStrong"
                        color="grayscale_800"
                        href={UNLIMITED_1ST_RENEW_REGULATIONS_LINK}
                        isUnderlined
                        mt={[12, 16]}
                        ml={36}
                        as="a"
                        target="_blank"
                        data-testId="unlimited-renew-advantages-regulations"
                    >
                        <FormattedMessage
                            id="annual.renew.advantages_modal_regulations"
                            defaultMessage="Zasady oferty"
                        />
                    </Text>
                </Box>
                <Box mt={[40, 48]} mb={[32, 0]}>
                    <Text variant="heading4" color="grayscale_900" mb={16}>
                        <FormattedMessage
                            id="annual.renew.advantages_modal_2y_caption"
                            defaultMessage="Po drugim roku:"
                        />
                    </Text>
                    <UnlimitedAdvantages
                        iconVariant="violet"
                        cardEdition="red"
                    />
                    <Text
                        variant="bodyStrong"
                        color="grayscale_800"
                        href={UNLIMITED_2ND_RENEW_REGULATIONS_LINK}
                        isUnderlined
                        mt={[12, 16]}
                        ml={36}
                        as="a"
                        target="_blank"
                        data-testId="unlimited-renew-advantages-regulations"
                    >
                        <FormattedMessage
                            id="annual.renew.advantages_modal_regulations"
                            defaultMessage="Zasady oferty"
                        />
                    </Text>
                </Box>
            </Box>
        </Modal>
    )
}

export default UnlimitedProlongingAdvantagesModal
